<script>
import Vue from 'vue'
import VueSvgIcon from 'vue-svgicon'
import 'vue-svgicon/dist/polyfill'
import '@/scripts/index.js'

/*
 * Components
 */
import '@/styles/app.scss'
import '@/styles/print.scss'

Vue.use(VueSvgIcon, {
    tagName: 'z-icon',
    classPrefix: 'z',
    isOriginalDefault: true
})

Vue.component('vue-raw', {
    props: ['raw'],
    render (h) {
        const div = document.createElement('div')
        div.innerHTML = this.raw
        return h(Vue.compile(div.outerHTML.replace(/\s{2,}/g, '')))
    }
})

Vue.directive('click-scroll-to-id', {
    bind: function (el, binding, vNode) {
        // Define Handler and cache it on the element
        const handler = (e) => {
            const argEl = document.getElementById(binding.arg)

            if (argEl !== null) {
                argEl.scrollIntoView({ behavior: 'smooth' })
            }
        }

        el.__vueClick__ = handler

        // add Event Listeners
        el.addEventListener('click', handler)
    },
    unbind: function (el, binding) {
        // Remove Event Listeners
        el.removeEventListener('click', el.__vueClick__)
        el.__vueClick__ = null
    }
})
Vue.directive('click-outside', {
    bind (el, binding, vnode) {
        el.clickOutsideEvent = (event) => {
            if (!(el === event.target || el.contains(event.target))) {
                vnode.context[binding.expression](event)
            }
        }
        document.body.addEventListener('click', el.clickOutsideEvent)
    },
    unbind (el) {
        document.body.removeEventListener('click', el.clickOutsideEvent)
    }
})

export default {
    name: 'App',
    components: {}
}
</script>
